const SmartwatchSvg = ({ color }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_15349_54153)">
        <path
          d="M9 1.5V0.75C9 0.3 8.7 0 8.25 0H3.75C3.3 0 3 0.3 3 0.75V1.5C2.175 1.5 1.5 2.175 1.5 3V9C1.5 9.825 2.175 10.5 3 10.5V11.25C3 11.7 3.3 12 3.75 12H8.25C8.7 12 9 11.7 9 11.25V10.5C9.825 10.5 10.5 9.825 10.5 9V3C10.5 2.175 9.825 1.5 9 1.5ZM3 9V3H9V9H3Z"
          fill={color ?? "#6D7075"}
        />
      </g>
      <defs>
        <clipPath id="clip0_15349_54153">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SmartwatchSvg;
